// extracted by mini-css-extract-plugin
export default {"licenseIssueCounts":"JKAo9zY_NMVHjEsQGnmg","iconGreen":"AjDSyK6gWHPz7tt0qZo1","iconRed":"arM7tgMzrTzrQRy03jDH","iconYellow":"jGLnTr7nzxz2VG_TS2Fv"};